import { apiCall } from "../../../services/api-service.js";

export const getGateListApi = async (term) => {
  const response = await apiCall("GET", "dockmaster/autosuggestion");
  return response;
};

export const getalertConfigApi = async () => {
  const response = await apiCall("GET", "get_alert_list");
  return response.data;
};
export const getalertDetailsApi = async (label) => {
  const response = await apiCall("GET", "alert_config/");
  return response.data;
};
export const alertSubmitApi = async (data) => {
  const response = await apiCall("POST", "alert_config", data);
  return response.data;
};

//Delete
export const getDeleteFieldsApi = async (id) => {
  const response = await apiCall("DELETE", `alert_config/${id}`);
  if (response?.status >= 400) {
    console.error("Error deleting alert config:", response);
    throw response;
  }
  return response;
};

//List
export const getListApi = async (term) => {
  const response = await apiCall("GET", `alert_config${term}`);
  if (response?.status >= 400) {
    console.error("Error fetching alert configs:", response);
    throw response;
  }
  return response;
};

//Gate
export const getDockListApi = async (term) => {
  const response = await apiCall("GET", "dockmaster/autosuggestion");
  return response;
};

//Update
export const updateConfigApi = async (id, data) => {
  const response = await apiCall("PUT", `alert_config/${id}`, data);
  return response;
};

//Edit

export const getEditConfigApi = async (id) => {
  const response = await apiCall("GET", `alert_config/${id}`);
  return response;
};

//Suggestionlist
export const getTypeListApi = async (term) => {
  const response = await apiCall("GET", "get_alert_list");
  return response;
};
